import { createTheme } from "@mui/material/styles";
import { cardShadow } from "./tokens";

const FONT_STACK = '"Plus Jakarta Sans", "Space Grotesk", "Work Sans", system-ui, sans-serif';

// Scoped theme for the redesigned student pages only — NOT mounted at the
// app root, so it never changes the look of Admin/Teacher/other screens
// that don't opt into it. `direction` stays the MUI default ('ltr'); RTL
// in this app is handled manually per-page via i18n.dir() + sx, and
// flipping theme.direction would double-mirror MUI's own internals
// (Menu anchors, icon margins, etc.) on top of that.
const darssyTheme = createTheme({
  palette: {
    primary: { main: "#2f6fed", dark: "#255ac9" },
    secondary: { main: "#7c3aed" },
    success: { main: "#16a34a" },
    warning: { main: "#ea7317" },
    text: { primary: "#101a33", secondary: "#64748b" },
    background: { default: "#f6f8fc", paper: "#ffffff" },
    divider: "#e6eaf2",
  },
  typography: {
    // MUI bakes `fontFamily` into every variant at creation time, so a lone
    // top-level override silently does nothing for h1-h6/body/button/etc —
    // each variant needs it explicitly (see StudentLogin.js's loginTheme).
    fontFamily: FONT_STACK,
    h1: { fontFamily: FONT_STACK },
    h2: { fontFamily: FONT_STACK },
    h3: { fontFamily: FONT_STACK },
    h4: { fontFamily: FONT_STACK },
    h5: { fontFamily: FONT_STACK },
    h6: { fontFamily: FONT_STACK },
    subtitle1: { fontFamily: FONT_STACK },
    subtitle2: { fontFamily: FONT_STACK },
    body1: { fontFamily: FONT_STACK },
    body2: { fontFamily: FONT_STACK },
    button: { fontFamily: FONT_STACK },
    caption: { fontFamily: FONT_STACK },
    overline: { fontFamily: FONT_STACK },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: "1px solid #e6eaf2",
          boxShadow: cardShadow,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 10, textTransform: "none", fontWeight: 600 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 999, fontWeight: 600 },
      },
    },
  },
});

export default darssyTheme;
